/* eslint-disable react/no-children-prop */
import React, { useContext, useEffect, useState } from 'react'
import { Platform, ScrollView, StyleSheet, Text, View } from 'react-native'
import * as Linking from 'expo-linking'
import { TemplatePage } from '../../../components/TemplatePage'
import { LogoutBigIcon } from '../../../components/LogoutBigIcon/LogoutBigIcon'
import { AuthContext } from '../../../context/Auth/AuthContext'
import { Cards } from '../components/Cards'
import { ChangeLanguage } from '../../../components/ChangeLanguage'
import { useTranslation } from 'react-i18next'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { useUserPermissions } from '../../../hooks/useUserPermissions'
import { corporateColor, white } from '../../../theme/colors'
import { paths } from '../../../api/pathsApi'
import { FreshWaterContext } from '../../../context/FreshWater/FreshWaterContext'
import { SeaWaterContext } from '../../../context/SeaWater/SeaWaterContext'
import { ControlServicesContext } from '../../../context/SeaWater/ControlServices/ControlServicesContext'
import { RootParams } from '../../../navigator/types'
import { NecropsyContext } from '../../../context/Necropsy/Provider'
import { NecropsyIcon } from '../../../components/Svg/NecropsyIcon'
import {
  ConsumptionIcon,
  ControlServicesIcon,
  FuelReceptionIcon,
  MonitorIcon,
  MortalityIcon,
  NecropsyRecordIcon,
  Rectangle,
  StatesIcon,
  UVFilterIcon,
} from '../../../components/Svg'
import { FuelContext } from '../../../context/Logistics/fuel/FuelProvider'
import { useApiUrls } from '../../../hooks/useSecureConfig'
import { SafeAreaView } from 'react-native-safe-area-context'

interface NavigationParams extends StackNavigationProp<RootParams, 'HomeScreen'> {}

export const HomeScreen = () => {
  const { user, tokenType } = useContext(AuthContext)
  const { hasData: hasDataFreshWater } = useContext(FreshWaterContext)
  const { hasData: hasDataSeaWater } = useContext(SeaWaterContext)
  const { hasData: hasDataControlService } = useContext(ControlServicesContext)
  const { hasData: hasDataNecropsy } = useContext(NecropsyContext)
  const { hasData: hasFuelData } = useContext(FuelContext)

  const { t } = useTranslation()
  const navigation = useNavigation<NavigationParams>()
  const { getPermissionsByAreaAndModule } = useUserPermissions()
  const [redirected, setRedirected] = useState(false)
  const apiUrls = useApiUrls()

  useEffect(() => {
    if (user.areaSelected === 'sweetWater' && hasDataFreshWater) return

    if (user.areaSelected === 'seaWater' && hasDataSeaWater) {
      if (getPermissionsByAreaAndModule('controlService') && hasDataControlService) {
        if (Platform.OS === 'web' && !redirected && tokenType === 'url') {
          navigation.navigate('ControlServicesStack', { screen: 'ControlServices' })
          setRedirected(true)
        }
        return
      }
      return
    }
    if (user.areaSelected === 'health' && hasDataNecropsy) return
    if (user.areaSelected === 'logistic' && hasFuelData) return
    navigation.navigate('AreaSelectorScreen')
  }, [])

  return (
    <ScrollView style={{ backgroundColor: corporateColor, flexGrow: 1 }}>
      <SafeAreaView edges={['top']}>
        <LogoutBigIcon backButton={user.assignedAreas! > 1} notificationsHeader />
      </SafeAreaView>

      <TemplatePage>
        <View style={{ justifyContent: 'center', alignItems: 'center', marginVertical: 24 }}>
          <Text style={styles.text}>{t('Selecciona un área a monitorear')}</Text>
          <Rectangle />
        </View>
        {getPermissionsByAreaAndModule('mortality') && (
          <Cards
            onPress={() => navigation.navigate('Mortality')}
            title='MORTALIDAD'
            children={<MortalityIcon />}
          />
        )}
        {getPermissionsByAreaAndModule('states') && (
          <Cards
            onPress={() => navigation.navigate('States')}
            title='ESTADOS'
            children={<StatesIcon />}
          />
        )}

        {getPermissionsByAreaAndModule('uvfilters') && (
          <Cards
            onPress={() => navigation.navigate('UVFilter')}
            title='FILTRO UV'
            children={<UVFilterIcon width={60} height={60} />}
          />
        )}

        {getPermissionsByAreaAndModule('controlService') && (
          <Cards
            onPress={() =>
              navigation.navigate('ControlServicesStack', { screen: 'ControlServices' })
            }
            title='CONTROL SERVICES'
            children={<ControlServicesIcon />}
          />
        )}

        {getPermissionsByAreaAndModule('necropsy') && (
          <>
            <Cards
              onPress={() => navigation.navigate('NecropsyStack', { screen: 'Necropsy' })}
              title='NECROPSIA'
              children={<NecropsyIcon />}
            />

            <Cards
              onPress={() => navigation.navigate('NecropsyStack', { screen: 'NecropsyRecords' })}
              title='REGISTROS NECROPSIA'
              children={<NecropsyRecordIcon />}
            />
          </>
        )}

        {getPermissionsByAreaAndModule('logistic') && (
          <>
            <Cards
              onPress={() => navigation.navigate('LogisticsStack', { screen: 'FuelReception' })}
              title='RECEPCIÓN COMBUSTIBLE'
              children={<FuelReceptionIcon width={40} height={40} />}
            />
            <Cards
              onPress={() => navigation.navigate('LogisticsStack', { screen: 'FuelConsumption' })}
              title='CONSUMO COMBUSTIBLE'
              children={<ConsumptionIcon width={40} height={40} />}
            />
          </>
        )}

        <Cards
          onPress={() =>
            Linking.openURL(`${paths().VIEW_WEB_MONITOR(apiUrls?.monitor)}${user.token}`)
          }
          title='MONITOR'
          children={<MonitorIcon />}
        />
        <ChangeLanguage />
      </TemplatePage>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  text: {
    fontSize: 16,
    color: white,
    marginBottom: 24,

    textAlign: 'center',
    fontWeight: '400',
  },
})
